<template>
   <b-modal
    ref="modal-bill-excel"
    hide-footer
    :title="titleExcel"
    id="modal-bill-excel"
    > <b-row class="mb-4"
      > <b-col cols="12"
        > <b-form-group label="Danh sách cần xuất:"
          > <b-form-radio-group v-model="selectedListExcel"
            > <b-form-radio value="all">Tất cả các trang</b-form-radio> <b-form-radio value="filter"
              >Theo bộ lọc</b-form-radio
            > </b-form-radio-group
          > </b-form-group
        > </b-col
      > <b-col cols="12"
        > <b-row v-if="selectedListExcel === 'all'"
          > <b-col md="4"
            > <b-form-group
              > <label>Từ ngày:</label> <date-picker
                placeholder="Từ ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="apiParams.fromDate"
              ></date-picker
              > </b-form-group
            > </b-col
          > <b-col md="4"
            > <b-form-group
              > <label>Đến ngày:</label> <date-picker
                placeholder="Tới ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="apiParams.toDate"
              ></date-picker
              > </b-form-group
            > </b-col
          > </b-row
        > </b-col
      > </b-row
    > <b-overlay
      :show="isDownloading"
      rounded
      opacity="0.6"
      class="d-inline-block mr-3"
      @hidden="$refs.button.focus()"
      > <template #overlay
        >
        <div class="d-flex align-items-center">
           <b-spinner
            variant="light"
            small
            type="grow"
          ></b-spinner
          >
        </div>
         </template
      > <b-button
        variant="primary"
        size="sm"
        @click="exportToExcelStream"
        > <v-icon
          small
          class="text-white"
          v-b-tooltip
          >mdi-download</v-icon
        > <strong>Xuất Excel</strong> </b-button
      > </b-overlay
    > <b-button
      style="width: 80px"
      variant="secondary"
      size="sm"
      @click="$bvModal.hide('modal-bill-excel')"
      > <strong>Hủy</strong> </b-button
    > </b-modal
  >
</template>

<script>
  import { validationMixin } from 'vuelidate'

  import { makeToastFaile, handleError } from '../../../utils/common'
  import { BASE_URL } from './../../../utils/constants'
  import axios from 'axios'
  import fileDownload from '../../../utils/file-download'
  import datePicker from 'vue-bootstrap-datetimepicker'
  // Import date picker css
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
  import moment from 'moment'
  import {
    isProductSearchSkipped,
    MIN_PRODUCT_SEARCH_LENGTH,
  } from '@/utils/productSearch'
  export default {
    props: ['param', 'mode'],
    mixins: [validationMixin],
    data() {
      return {
        dpConfigs: {
          date: {
            format: 'DD/MM/YYYY',
            useCurrent: false,
            showClear: true,
            showClose: true,
            minDate: false,
            maxDate: false,
            locale: 'vi',
            sideBySide: true,
          },
        },
        selectedListExcel: 'all',
        apiParams: null,
        titleExcel: 'Xuất excel hoá đơn bán lẻ',
        types: [],
        isDownloading: false,
      }
    },
    components: {
      datePicker,
    },
    computed: {},
    created() {},
    watch: {
      $props: {
        handler() {
          switch (this.mode) {
            case 1:
              this.titleExcel = 'Xuất excel hoá đơn bán lẻ'
              this.types = [1]
              break
            case 4:
              this.titleExcel = 'Xuất excel hoá đơn giao hàng'
              this.types = [4]
              break
            case 2:
              this.titleExcel = 'Xuất excel hoá đơn bán buôn'
              this.types = [2]
              break
            case 3:
              this.titleExcel = 'Xuất excel hoá đơn trả hàng'
              this.types = [3]
              break
            default:
              this.titleExcel = 'Không xác định'
              break
          }
          this.apiParams = { ...this.param }
        },
        deep: true,
        immediate: true,
      },
    },
    validations: {},
    methods: {
      async exportToExcelStream() {
        const apiParams = this.getParamFilters()

        if (!apiParams) {
          return
        }

        this.isDownloading = true
        const baseUrl = BASE_URL

        try {
          // 1) Enqueue job export chạy nền (không sinh file trong request).
          const createRes = await axios.post(`${baseUrl}v1/report-exports`, {
            reportKey: 'bills',
            params: apiParams,
          })
          const jobCode = createRes.data && createRes.data.data && createRes.data.data.jobCode
          if (!jobCode) {
            throw new Error('Không tạo được job export')
          }

          // 2) Poll trạng thái tới khi SUCCESS/FAILED.
          const job = await this.pollReportExport(baseUrl, jobCode)
          if (!job || job.status !== 'SUCCESS') {
            throw new Error((job && job.errorMessage) || 'Xuất Excel thất bại, vui lòng thử lại')
          }

          // 3) Tải file từ storage qua link download.
          const dlRes = await axios.get(`${baseUrl}v1/report-exports/${jobCode}/download`, {
            responseType: 'blob',
          })
          const fileName = fileDownload.getFileName(dlRes)
          fileDownload.createFile(dlRes.data, fileName)
        } catch (err) {
          // Lỗi ở bước download là blob → parse JSON để lấy message.
          try {
            if (err.response && err.response.data && typeof err.response.data.text === 'function') {
              const text = await err.response.data.text()
              err.response.data = JSON.parse(text)
            }
          } catch (_) {}
          handleError(err)
          this.$nprogress.done()
        } finally {
          this.isDownloading = false
        }
      },
      /** Poll job report-export tới khi hoàn tất hoặc hết thời gian chờ. */
      pollReportExport(baseUrl, jobCode, { intervalMs = 2000, timeoutMs = 300000 } = {}) {
        const startedAt = Date.now()
        const tick = async () => {
          const res = await axios.get(`${baseUrl}v1/report-exports/${jobCode}`)
          const job = res.data && res.data.data
          if (job && (job.status === 'SUCCESS' || job.status === 'FAILED')) {
            return job
          }
          if (Date.now() - startedAt > timeoutMs) {
            throw new Error('Xuất Excel quá thời gian chờ, vui lòng kiểm tra lại sau')
          }
          await new Promise((resolve) => setTimeout(resolve, intervalMs))
          return tick()
        }
        return tick()
      },
      getValuesMultiSelect(arr, prop) {
        return arr.reduce((accumulator, currentValue) => {
          if (currentValue.checked) accumulator.push(currentValue[prop])
          return accumulator
        }, [])
      },
      /**
       * Bộ lọc truyền từ List: có thể là DD/MM/YYYY (date-picker) hoặc đã chuẩn hóa
       * yyyy-MM-dd / yyyy-MM-dd HH:mm từ updateFilter; parse sai gây "Invalid date" trên API.
       */
      parseFilterDateInput(value) {
        if (value == null || value === '') {
          return null
        }
        const v = String(value).trim()
        if (!v) {
          return null
        }
        if (/^\d{4}-\d{2}-\d{2}/.test(v)) {
          const m = moment(v)
          return m.isValid() ? m : null
        }
        let m = moment(v, 'DD/MM/YYYY', true)
        if (m.isValid()) {
          return m
        }
        m = moment(v, 'DD/MM/YYYY HH:mm', true)
        if (m.isValid()) {
          return m
        }
        m = moment(v)
        return m.isValid() ? m : null
      },
      /** storeIds / criteriaIds từ List là mảng id; filter gốc là object { id } — không dùng .code. */
      normalizeIdList(list) {
        if (!list || !Array.isArray(list) || !list.length) {
          return []
        }
        return list
          .map((item) => {
            if (item == null) {
              return null
            }
            if (typeof item === 'object') {
              if (item.id != null) {
                return item.id
              }
              if (item.code != null) {
                return item.code
              }
              return null
            }
            return item
          })
          .filter((id) => id != null && String(id) !== 'undefined')
      },
      getParamFilters() {
        const DATE_DB_FORMAT = 'YYYY-MM-DD'

        // Ưu tiên ngày người dùng chỉnh trong modal; nếu trống/không hợp lệ (vd date-picker
        // clear giá trị yyyy-MM-DD copy từ bộ lọc), fallback về bộ lọc cha (this.param) để
        // KHÔNG mặc định fromDate về 1991 — nguyên nhân báo nhầm "chọn trong vòng 3 tháng".
        const fromM =
          this.parseFilterDateInput(this.apiParams.fromDate) ||
          this.parseFilterDateInput(this.param && this.param.fromDate)
        const toM =
          this.parseFilterDateInput(this.apiParams.toDate) ||
          this.parseFilterDateInput(this.param && this.param.toDate)

        const fromDate = fromM ? fromM.format(DATE_DB_FORMAT) : '1991-01-01'

        const toDate = toM ? toM.format(DATE_DB_FORMAT) : moment().format(DATE_DB_FORMAT)

        const apiParams = {
          fromDate: fromDate,
          toDate: toDate,
          types: this.types,
        }

        if (this.selectedListExcel === 'filter') {
          const diff = this.getDaysDiff(apiParams.fromDate, apiParams.toDate)

          if (
            diff > 100 &&
            (!this.apiParams.customerPhoneSearch ||
              String(this.apiParams.customerPhoneSearch).trim() === '') &&
            (!this.apiParams.customerNameSearch ||
              String(this.apiParams.customerNameSearch).trim() === '')
          ) {
            makeToastFaile('Vui lòng chọn khoảng thời gian trong vòng 3 tháng!')
            return null
          }
          const productSearch = this.apiParams.productSearch || ''

          if (productSearch.trim() && isProductSearchSkipped(productSearch)) {
            makeToastFaile(
              `Tên sản phẩm phải từ ${MIN_PRODUCT_SEARCH_LENGTH} ký tự trở lên`,
            )
            return null
          }

          const customerNameSearch = (this.apiParams.customerNameSearch || '').trim()
          if (customerNameSearch && customerNameSearch.length < 3) {
            makeToastFaile('Vui lòng nhập tên khách hàng tối thiểu 3 ký tự')
            return null
          }

          const param = this.param || {}
          const criteriaIds = this.normalizeIdList(param.criteriaIds)
          const storeIds = this.normalizeIdList(param.storeIds)

          return {
            ...this.apiParams,
            ...apiParams,
            productSearch: productSearch ? productSearch.trim() : null,
            customerNameSearch: customerNameSearch || null,
            criteriaIds: criteriaIds,
            storeIds: storeIds,
          }
        }

        const diff = this.getDaysDiff(apiParams.fromDate, apiParams.toDate)
        if (diff > 32) {
          makeToastFaile('Vui lòng chọn khoảng thời gian trong vòng 1 tháng!')
          return null
        }

        return apiParams
      },
      getDaysDiff(startDate, endDate, dateFormat = 'YYYY-MM-DD') {
        const getDateAsArray = (date) => {
          return moment(date.split(/\D+/), dateFormat)
        }
        return getDateAsArray(endDate).diff(getDateAsArray(startDate), 'days') + 1
      },
    },
  }
</script>

